// extracted by mini-css-extract-plugin
export const container = "Hero-module--container--1Fm05";
export const statement = "Hero-module--statement--3nYY7";
export const icon = "Hero-module--icon--1ssIv";
export const hoverBounce = "Hero-module--hover-bounce--aBN_H";
export const bounce = "Hero-module--bounce--11K67";